<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Dodawanie statusu"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-select :values="options" :model="$schema.type" />
      </div>

      <div class="form-group col-12">
        <w-select :values="stages" :model="$schema.stageId" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.color" />
      </div>

      <div v-if="show" class="form-group col-12">
        <w-checkbox :model="$schema.start" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { StageTypeList } from '@/enums/stageType.enum';
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/status.schema';

const emptyData = () => ({
  name: null,
  type: null,
  templateId: null,
  stageId: null,
  start: false,
  color: null
});

// @vuese
// Modal dodania statusu
// @group Status
export default {
  mixins: [manageMixin('status', {}, emptyData), formMixin],
  props: {
    // Identyfikator szablonu
    templateId: {
      type: Number,
      required: true
    }
  },
  schema,
  data: () => ({
    model: {},
    options: StageTypeList
  }),
  computed: mapState({
    stages(state) {
      return state.stage.list
        .filter(stage => !this.$schema.$model.type || stage.type === this.$schema.$model.type)
        .map(stage => ({ value: stage.id, text: stage.name }));
    }
  }),
  watch: {
    show() {
      this.$schema.$model.templateId = this.templateId;
    }
  }
};
</script>
